import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Inter Dependency
import { ButtonsModule } from '../button/button.module';
import { CheckboxModule } from '../checkBox/checkbox.module';
import { IconModule } from '../icon/icon.module';
import { InputModule } from '../input/input.module';
import { RadioButtonModule } from '../radio-button/radio-button.module';
import { AxisInputAutoResizeDirective } from '../utilities/input-auto-resize.directive';
import { DropdownMenuComponent } from './dropdown-menu.component';
import { DropdownComponent } from './dropdown.component';
import { DropdownListComponent } from './dropdownList.component';
import { HighlighterPipe } from './highlighter.pipe';
import { UtilsModule } from './../utilities/utils.module';

@NgModule({
  imports: [
    ButtonsModule,
    CommonModule,
    CheckboxModule,
    FormsModule,
    HttpClientModule,
    IconModule,
    InputModule,
    RadioButtonModule,
    UtilsModule
  ],
  declarations: [
    AxisInputAutoResizeDirective,
    DropdownComponent,
    DropdownListComponent,
    DropdownMenuComponent,
    HighlighterPipe,
  ],
  entryComponents: [DropdownMenuComponent],  
  exports: [DropdownComponent, DropdownListComponent, DropdownMenuComponent]
})
export class DropdownModule {}
